import {createIcon} from '@chakra-ui/react';

/** Platillos de choque (dos discos enfrentados), distinto de caja/bombo. */
export const IconoPlatillos = createIcon({
  displayName: 'IconoPlatillos',
  viewBox: '0 0 64 64',
  path: (
    <>
      {/* Disco izquierdo */}
      <ellipse
        cx="22"
        cy="32"
        rx="14"
        ry="20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        transform="rotate(-18 22 32)"
      />
      <ellipse
        cx="22"
        cy="32"
        rx="5"
        ry="7"
        fill="currentColor"
        opacity="0.22"
        transform="rotate(-18 22 32)"
      />
      {/* Disco derecho */}
      <ellipse
        cx="42"
        cy="32"
        rx="14"
        ry="20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        transform="rotate(18 42 32)"
      />
      <ellipse
        cx="42"
        cy="32"
        rx="5"
        ry="7"
        fill="currentColor"
        opacity="0.22"
        transform="rotate(18 42 32)"
      />
      {/* Empuñaduras */}
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        d="M10 28c-3 1.5-4 4-4 6s1 4.5 4 6M54 28c3 1.5 4 4 4 6s-1 4.5-4 6"
      />
    </>
  ),
});
